import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Formulario = () => {
  const form = useRef();
  const [showTick, setShowTick] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_fluf3cq",
        "template_cerkl4j",
        form.current,
        "EdMp1RitbnRiwCh98"
      )
      .then(
        (result) => {
          console.log(result.text);
          setShowTick(true);
          form.current.reset();
          setIsChecked(false);

          setTimeout(() => {
            setShowTick(false);
          }, 3000);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <>
      {showTick && (
        <div className="formulario__success">
          <span>✓</span>
        </div>
      )}

      <form ref={form} onSubmit={sendEmail} className="formulario gradient-border">
        <input
          type="text"
          name="nombre"
          placeholder="Nombre y apellidos"
          className="formulario__input"
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Correo"
          className="formulario__input"
          required
        />

        <input
          type="tel"
          name="tlfno"
          placeholder="Teléfono"
          className="formulario__input"
        />

        <textarea
          name="mensaje"
          placeholder="Mensaje"
          className="formulario__textarea"
          required
        ></textarea>

        <div className="formulario__legal">
          <p className="formulario__legal-text">
            <strong>Información sobre Protección de Datos</strong>
            <br />
            Responsable: Juan Manuel Pizarro López (JF PIMI). Finalidad:
            Ponernos en contacto contigo y atender las consultas y solicitudes
            de información que nos remitas a través de formularios habilitados
            en nuestra página web. Asimismo, para remitirte comunicaciones
            comerciales de productos y servicios comercializados por nuestra
            Entidad. Legitimación: Ejecución de medidas precontractuales a
            solicitud del interesado. Destinatarios: No se cederán sus datos a
            terceros, salvo obligación legal. Derechos: como titular de los
            datos usted tiene derecho a acceder, rectificar, suprimir y
            oponerse al tratamiento de sus datos, así como otros derechos,
            dirigiéndose a la dirección de correo electrónico jfpimic@gmail.com.
            Información adicional: Puede consultar la información adicional y
            detallada sobre Protección de datos en nuestra página web, apartado
            de “Protección de datos”.
          </p>

          <label className="formulario__checkbox">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <span>He leído y acepto la política de protección de datos</span>
          </label>
        </div>

        <button
          type="submit"
          className="formulario__submit"
          disabled={!isChecked}
        >
          Enviar
        </button>
      </form>
    </>
  );
};

export default Formulario;